module.exports = __webpack_public_path__ + "static/img/matanza-digital-1.6980286.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/matanza-digital-1.jpg
// module id = UykI
// module chunks = 1